import createStyled from "../createStyled/index.mjs";
const styled = createStyled();
export default styled;